<template>
    <div id="app">
        <Header></Header>

        <Search v-if="!$route.meta.noFooter"></Search>

        <Tab v-if="!$route.meta.noTable"></Tab>

        <Breadcrumb v-if="$route.meta.name"></Breadcrumb>
        <div class="warp">
            <router-view />
        </div>

        <!-- <commodityDetails></commodityDetails> -->


        <!-- <commodityDetails></commodityDetails> -->

        <Footer v-if="!$route.meta.noFooter"></Footer>
        <RightTab v-if="!$route.meta.noFooter"></RightTab>
    </div>
</template>

<script>
    import Header from './components/Header'
    import Tab from './components/Tab'
    import Breadcrumb from './components/Breadcrumb'
    import Search from "./components/Search"
    import Footer from './components/Footer'
    import RightTab from './components/RightTab'

    export default {
        name: 'App',
        components: {
            Header,
            Tab,
            Breadcrumb,
            Search,
            Footer,
            RightTab
        }
    }
</script>

<style>
    @import url("assets/css/reset.css");
    @import url("assets/css/style.css");
    @import url("assets/icon/iconfont.css");
    @import url("assets/iconfont/iconfont.css");

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        /* width: 1200px; */
        min-height: 100vh;
        margin: 0 auto;
    }
</style>



// WEBPACK FOOTER //
// src/App.vue